import { onLCP, onFID, onCLS } from 'web-vitals';

import MetricsService from './service/index';
import createObserverEntryTypes from './factories/entryTypes';
import getMetricEntryType from './getMetricEntryType';

class MetricalClient {
    constructor({ apiKey, apiUrl, domain, debug }) {
        this.apiKey = apiKey;
        this.domain = domain;
        this.service = new MetricsService({ apiKey, domain, apiUrl, debug });
        this.entryTypes = createObserverEntryTypes();
        this.setupObserver();
        this.track = this.track.bind(this);
        window.performanceDataLayer = [];
        // Track Web Vitals
        onCLS(this.track);
        onFID(this.track);
        onLCP(this.track);
    }

    setupObserver() {
        const observer = new PerformanceObserver((list) => {
            for (let item of list.getEntries()) {
                this.track(item);
            }
        });
        try {
            // Buffered flag will access historical entries
            this.entryTypes.forEach((eventType) => {
                observer.observe({
                    type: eventType,
                    buffered: true,
                    entryTypes: this.entryTypes,
                });
            });
        } catch (_) {
            // Fallback to only observing future entries
            // The downside here is we won't get historical entries
            observer.observe({ entryTypes: this.entryTypes });
        }
    }

    track(item) {
        const payload = getMetricEntryType(item);
        this.service.track(payload);
    }
}

export default MetricalClient;
